import React from "react"
import { connect } from "react-redux"
import StatCell from "sheets/components/cells/StatCell"
import { percentageCellConnection } from "sheets/selectors/cell-selectors"

export const PercentageCell = ({ value, ...props }) => (
    <StatCell isRenderingPercent {...props}>
        {value}
    </StatCell>
)

export default connect(percentageCellConnection)(PercentageCell)
